import React from "react";
import { Box, Card, Typography } from "@mui/material";

export interface KpiCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  iconColor?: string;
  subValue?: string;
  variance?: string;
  varianceType?: string;
  children?: React.ReactNode;
}

export const KpiCard: React.FC<KpiCardProps> = ({
  label,
  value,
  icon,
  iconColor,
  subValue,
  variance,
  varianceType,
  children,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: children ? "column" : "row",
        alignItems: children ? "stretch" : "center",
        justifyContent: "space-between",
        borderColor: "divider",
        gap: 2,
        px: 3,
        py: 2,
        width: "100%",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: children ? "100%" : "auto",
          flex: children ? 0 : 1,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
          <Box display="flex" alignItems="baseline" gap={1}>
            <Typography variant="h6" color="text.primary">
              {value}
            </Typography>
            {variance && (
              <Typography
                variant="body2"
                sx={{
                  color:
                    varianceType === "positive"
                      ? "success.main"
                      : varianceType === "negative"
                      ? "error.main"
                      : "text.secondary",
                  fontWeight: 600,
                }}
              >
                {variance}
              </Typography>
            )}
          </Box>
          {subValue && (
            <Typography variant="caption" color="text.secondary">
              {subValue}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            color: iconColor || "primary.main",
            display: "flex",
            alignItems: "center",
          }}
        >
          {icon}
        </Box>
      </Box>
      {children}
    </Card>
  );
};
